var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region imports

//models
import model from '../base.model';
import { loginModel } from '../auth/login.model';

//storage
import { save as settingsSave, get as settingsGet, getServerUrl as settingsGetServerUrl, init as settingsInit, getInitialState as settingsGetInitialSettings } from '../../device/settings.storage';

//helpers
import { isEmpty } from '../../utils/helpers';
import { returnPromise } from '../../utils/helpers';

//constants
import urls from '../../constants/urls.constant';
import { METHOD } from '../../api/constants';

//endregion


class settingsModel extends model {

    //endregion

    //region action api

    //region init

    static apiGet(requestMethod, params = {}) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapToServerGet(params);
            const { urlParams, authParams } = serverModel;
            const url = urls.service.getSettings(urlParams);
            const serverUrl = yield settingsGetServerUrl();
            // return requestMethod(serverUrl, url, serverModel.payload, authParams);
            return returnPromise({});
        })();
    }

    static apiPost(requestMethod, params = {}) {
        var _this2 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this2.mapToServerPost(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const url = urls.service.getSettings(urlParams);
            const serverUrl = yield settingsGetServerUrl();
            // return requestMethod(serverUrl, url, serverModel.payload, authParams);
            return returnPromise(serverModel.payload);
        })();
    }

    static processServerResponse(dispatch, params, model, serverResponse, history, clientApiMethod, requestMethod) {
        switch (requestMethod) {
            case METHOD.GET:
                {
                    const modelClient = model.mapToClient(serverResponse);
                    // added settings from storage to all settings
                    settingsGet().then(data => {
                        const settings = _extends({}, settingsGetInitialSettings(), data);
                        modelClient.settings = settings;
                        dispatch(model.dispatchModel({ modelClient, model }));
                    });
                    break;
                }
            case METHOD.POST:
                {
                    dispatch(model.dispatchRequest({ model }));
                    settingsSave(params.settings, model.MODEL_NAME).then(data => {
                        const { settings } = params;
                        dispatch(model.dispatchOnChangeSettings({ settings, model }));
                        // history.goBack();
                    });
                    break;
                }
            default:
                break;
        }
    }

    //endregion

    //region actions

    static actionStorageInit(model) {
        return dispatch => {
            const cb = data => {
                const settings = _extends({}, settingsGetInitialSettings(), data);

                dispatch({
                    type: model.TYPE__ON_STORAGE_INIT,
                    payload: {
                        model,
                        modelClient: {
                            settings
                        }
                    }
                });
            };
            return settingsInit(cb, model.MODEL_NAME);
        };
    }

    static dispatchOnChangeSettings(params = {}) {
        const { model, settings } = params;
        return {
            type: model.TYPE__ON_CHANGE_SETTINGS,
            payload: {
                model,
                settings
            }
        };
    }

    //endregion

    //region mapper

    static mapToClient(serverModel) {
        if (isEmpty(serverModel)) {
            return serverModel;
        }

        const { setting1, settings } = serverModel;
        return {
            setting1,
            settings
        };
    }

    static mapToServerGet(params) {
        if (super.isEmpty(params)) {
            return {};
        }

        return {
            urlParams: {}
        };
    }

    /*
     * Pass to server all settings except settings for ip:port !
     * Which is saving locally
     */
    static mapToServerPost(params) {
        if (super.isEmpty(params)) {
            return {};
        }

        const { setting1 } = params;
        return {
            payload: {
                setting1
            }
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE__ON_CHANGE_SETTINGS]: model.reduceOnChangeSettings,
            [model.TYPE__ON_STORAGE_INIT]: model.reduceGet.bind(model)
        };

        return reducers[type];
    }

    static reduceOnChangeSettings(stateModel, action) {
        const { model, settings } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                settings,
                isLoading: false
            })
        };
    }
}

settingsModel.MODEL_NAME = 'settingsModel';
settingsModel.TYPE_REQUEST = 'REQUEST_SETTINGS';
settingsModel.TYPE_FROM_SERVER = 'GET_SETTINGS';
settingsModel.TYPE_CLEAR = 'CLEAR_SETTINGS';
settingsModel.TYPE__ON_STORAGE_INIT = 'TYPE_SETTINGS__STORAGE_INIT';
settingsModel.TYPE__ON_CHANGE_SETTINGS = 'TYPE__SETTINGS__ON_CHANGE';
export { settingsModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/service/settings.model.js